// state slice for maitaining filters for the play table
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { MultiSelectItem } from "../../components/multi-select";

export interface PlayFilterSlice {
  selectedSeason?: MultiSelectItem;
  selectedTeam?: MultiSelectItem;
  selectedSeries?: MultiSelectItem;
  selectedTag?: MultiSelectItem;
  selectedPlayNameFilter?: string;
}

const initialState: PlayFilterSlice = {};

export const playFilterSlice = createSlice({
  name: "playFilter",
  initialState,
  reducers: {
    setPlayFilter: (
      state,
      action: PayloadAction<
        Pick<
          PlayFilterSlice,
          "selectedSeason" | "selectedTeam" | "selectedSeries" | "selectedTag" | "selectedPlayNameFilter"
        >
      >
    ) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setPlayFilter } = playFilterSlice.actions;
export const playFilterSliceReducer = playFilterSlice.reducer;
